// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  PRODUCT_FIELD_TYPE_DATA,
  ProductFieldType,
} from '@/constants/product-field-type';
import { ItemFieldTypeIcon } from '@/items/components/item-field-type-icon';
import { Typography, TypographyProps } from '@mui/material';

interface Props extends Pick<TypographyProps, 'height'> {
  /**
   * The type of item field to display.
   */
  type: ProductFieldType;
}

/**
 * A component that displays an item field's type with an icon and label.
 */
export function ItemFieldTypeLabel(props: Props) {
  return (
    <Typography
      color="text.secondary"
      display="flex"
      alignItems="center"
      height={props.height}
    >
      <ItemFieldTypeIcon type={props.type} />
      <Typography variant="overline" marginLeft={1}>
        {PRODUCT_FIELD_TYPE_DATA[props.type].fieldTypeLabel}
      </Typography>
    </Typography>
  );
}
